import { render, staticRenderFns } from "./NumberInputDefault.vue?vue&type=template&id=2aff3335&"
import script from "./NumberInputDefault.vue?vue&type=script&lang=js&"
export * from "./NumberInputDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports